<template>
  <button type="submit" :disabled="!enabled || isSubmitting" v-html="label"></button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Number,
      default: 20000 // 20 secondi di default
    }
  },
  data() {
    return {
      enabled: !this.disabled,
      isSubmitting: false // Flag per indicare se il form è in fase di invio
    }
  },
  mounted() {
    // Emettiamo l'evento 'register-submit' per scopi esterni, se necessario.
    // L'invio multiplo viene gestito diversamente ora.
    this.$root.$emit('register-submit', this);

    // Trova il form genitore e aggiungi un listener per l'evento 'submit'
    let form = this.$el.closest('form');
    if (form) {
      form.addEventListener('submit', this.handleFormSubmit);
    }
  },
  beforeDestroy() {
    // Rimuovi il listener quando il componente viene distrutto per evitare memory leaks
    let form = this.$el.closest('form');
    if (form) {
      form.removeEventListener('submit', this.handleFormSubmit);
    }
  },
  methods: {
    handleFormSubmit(event) {
      if (this.isSubmitting) {
        // Se il form è già in fase di invio, previene l'invio multiplo
        event.preventDefault();
        return false;
      }

      // Imposta il flag per indicare che il form è in fase di invio
      this.isSubmitting = true;

      // Disabilita il pulsante
      this.enabled = false;

      // Riabilita il pulsante e resetta il flag dopo il timeout
      setTimeout(() => {
        this.enabled = true;
        this.isSubmitting = false;
      }, this.timeout);
    }
  }
}
</script>


// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/forms/assets/js/components/FormSubmit.vue